import { post, get } from '@/request/http';

const InteligentMatchPage = {
  // 智能推荐查询推荐结果
  recommendResult(params) {
    return post(
      '/backloansuper/loan/supermarket/queryRecommendResult/v1.0',
      params,
    );
  },
  //   获取推荐列表
  queryMatchList(params) {
    return post(
      '/backloansuper/loan/supermarket/queryRecommendList/v1.0',
      params,
    );
  },
  // 获取非推荐列表的智能列表
  queryNoMatchList(params) {
    return post(
      '/backloansuper/loan/supermarket/queryMoreRecommendList/v1.0',
      params,
    );
  },
};
export default InteligentMatchPage;
